module.exports = __webpack_public_path__ + "img/canada-respiratory-diseases-male.78169c85.png";